import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  ActionTypeEnum,
  calcTypeApiResponseModel,
  CalcTypeEnum,
  GenericSearchRequestModel,
  HasFormIdModel,
} from "../../models";
import { TableColumn } from "react-data-table-component";
import {
  checkActionPrivilege,
  getLabelName,
  isArabicCurrentLanguage,
} from "../../utils";
import { getAllCalcTypes } from "../../serviceBroker/calcTypeServiceBroker";
import {
  ButtonBox,
  LoadingBox,
  GridTable,
  SearchBox,
  PrivilegesChecker,
} from "..";
import { useSearchBox } from "../../hooks";

interface CalcTypeListProps extends HasFormIdModel {
  calcType: CalcTypeEnum;
  setIsRefresh: Dispatch<SetStateAction<boolean>>;
  isRefresh: boolean;
  onActionEvent?: any | null;
}

export const CalcTypeList: FC<CalcTypeListProps> = ({
  calcType,
  setIsRefresh,
  isRefresh,
  onActionEvent,
  formId,
}) => {
  //#region variables
  const isArabic: boolean = isArabicCurrentLanguage();
  //#endregion
  //#region state
  const [searchParams] = useState<GenericSearchRequestModel>({
    pageSize: 10,
    pageNumber: 1,
  });
  const [data, setData] = useState<calcTypeApiResponseModel[]>([]);
  // Add a new state for filtered data
  const [filteredData, setFilteredData] = useState<calcTypeApiResponseModel[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const { onChange, onSearch, searchedWord, value } = useSearchBox();
  //#endregion

  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      const listData = await getList();
      setData(listData);
      setFilteredData(listData); // Initially set filtered data to all data
      setLoading(false);
      setIsRefresh(false);
    };
    fillData().then(() => {});
  }, []);

  useEffect(() => {
    const fillData = async () => {
      if (isRefresh) {
        setLoading(true);
        const listData = await getList();
        setData(listData);
        setFilteredData(listData); // Update filtered data when refreshing
        setLoading(false);
        setIsRefresh(false);
      }
    };
    fillData().then(() => {});
  }, [isRefresh]);

  // Add search filtering effect
  useEffect(() => {
    const searchValue =
      searchedWord && searchedWord.trim() !== "" ? searchedWord : value;

    if (!searchValue.trim()) {
      // If search is empty, show all data
      setFilteredData(data);
    } else {
      setFilteredData(() => {
        return data.filter(
          (item) =>
            // Check if these properties exist in your model and adjust accordingly
            item.Name?.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.EnglishName?.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    }
  }, [searchedWord, value, data]);
  //#endregion

  //#region functions
  const getList = async (): Promise<calcTypeApiResponseModel[]> => {
    const priceList = await getAllCalcTypes(calcType !== CalcTypeEnum.CalcType);
    return priceList !== null &&
      priceList !== undefined &&
      priceList.Result !== null &&
      priceList.Result !== undefined &&
      priceList.Result?.length !== 0
      ? priceList.Result
      : [];
  };
  //#endregion

  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      <PrivilegesChecker formId={formId} action="EnableSearch">
        <SearchBox
          onChangeHandler={onChange}
          onSearchHandler={onSearch}
          searchedWord={value}
          name="name"
        />
      </PrivilegesChecker>
      <GridTable
        // columns={columns}
        data={filteredData}
        totalRows={filteredData.length}
        currentPage={searchParams.pageNumber}
        pageSize={searchParams.pageSize}
        // onCurrentPageChange={onCurrentPageChange}
        // onPageSizeChange={onPageSizeChange}        paginationType="client"
        columnsProps={{
          onActionEvent,
          isArabic,
          actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
        }}
        formId={formId}
      />
    </>
  );
  //#endregion
};
